function markGiftItemsFromCart() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      cart.items.forEach((item) => {
        if (!(item.properties?.gwp === "true")) return;

        // Attempt to find item node by title
        const allItems = document.querySelectorAll(".shopping-cart__item");
        const match = Array.from(allItems).find((el) =>
          el.textContent.includes(item.product_title)
        );

        if (match) {
          match.classList.add("is-gift-item");

          if (!match.querySelector(".shopping-cart__item__properties")) {
            const propsContainer = document.createElement("ul");
            propsContainer.className = "shopping-cart__item__properties";

            const propItem = document.createElement("li");
            propItem.textContent = "gwp: true";
            propsContainer.appendChild(propItem);

            match.appendChild(propsContainer);
          }
        }
      });
    });
}

document.addEventListener("DOMContentLoaded", () => {
  markGiftItemsFromCart();
  const cartContainer = document.querySelector(".shopping-cart__primary");

  if (!cartContainer) return;

  new MutationObserver(() => {
    markGiftItemsFromCart();
  }).observe(cartContainer, {
    childList: true,
    subtree: true,
  });
});
